import { Link } from 'react-router-dom';
import { getRecentArticles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'article-security-001': 'https://readdy.ai/api/search-image?query=Chinese%20technology%20blog%20article%20header%20image%20about%20login%20security%20protection%2C%20warm%20minimalist%20style%20with%20soft%20lighting%2C%20clean%20background%2C%20professional%20atmosphere%2C%20shield%20icon%20concept%2C%20warm%20coral%20and%20neutral%20tones%2C%20corporate%20blog%20aesthetic%2C%20sophisticated%20design&width=800&height=450&seq=article-security-001&orientation=landscape',
  'article-device-002': 'https://readdy.ai/api/search-image?query=Chinese%20technology%20blog%20article%20header%20image%20about%20multi%20device%20login%2C%20warm%20minimalist%20style%20with%20soft%20lighting%2C%20clean%20background%2C%20smartphone%20and%20laptop%20concept%2C%20warm%20amber%20and%20neutral%20tones%2C%20corporate%20blog%20aesthetic%2C%20sophisticated%20design&width=800&height=450&seq=article-device-002&orientation=landscape',
  'article-update-003': 'https://readdy.ai/api/search-image?query=Chinese%20technology%20blog%20article%20header%20image%20about%20software%20update%20new%20version%2C%20warm%20minimalist%20style%20with%20soft%20lighting%2C%20clean%20background%2C%20modern%20interface%20concept%2C%20warm%20coral%20and%20neutral%20tones%2C%20corporate%20blog%20aesthetic%2C%20sophisticated%20design&width=800&height=450&seq=article-update-003&orientation=landscape',
};

export default function ArticleSection() {
  const recentArticles = getRecentArticles(3);

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-14 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新文章
            </h2>
            <p className="text-sm text-foreground-600">
              了解开云登录的最新动态和安全知识
            </p>
          </div>
          <Link
            to="/category/anquan-denglu"
            className="flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {recentArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={articleImages[article.imageSeq] || articleImages['article-security-001']}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="whitespace-nowrap">{article.date}</span>
                  <span className="whitespace-nowrap">{article.readTime}阅读</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}